import { SVGProps } from 'react';

export function SvgComponent({
  width = 29,
  height = 28,
  ...props
}: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 29 28"
      {...props}
    >
      <path
        transform="matrix(0.99863 0.052336 -0.052336 0.99863 1.40051 0.0190105)"
        d="M22.281439 14.999041C21.738876 15.021917 21.279409 14.633011 21.254969 14.12972L20.536442 1.1219364C20.512001 0.61864555 20.927477 0.18856056 21.465151 0.16110831L24.793844 0.00097029412C25.336407 -0.021906566 25.795874 0.3624247 25.820312 0.87029099L26.533955 13.878074C26.563282 14.381365 26.147806 14.81145 25.610132 14.838902L22.281439 14.999041ZM11.493123 24.611111C10.985529 25.185448 10.113391 25.232141 9.5458088 24.718508L9.0520582 23.957396C8.6275253 23.299009 8.5629225 22.467855 8.8720932 21.748768L11.013216 16.771185L3.9576628 17.135399C2.5548582 17.210108 1.2674158 16.360277 0.76905102 15.034167L0.2383848 13.624007C-0.070785962 12.792853 -0.080014937 11.877651 0.21531235 11.041828L3.1455128 2.7209523C3.5838892 1.4742218 4.7236681 0.61972123 6.0295682 0.5543496L15.733838 0.078070521C17.108955 0.0080294805 18.28565 1.0866615 18.359482 2.473474L18.996283 15.090199C19.033197 15.781271 18.793245 16.42565 18.364098 16.906597L11.493123 24.611111Z"
      />
    </svg>
  );
}

export default SvgComponent;
